module.exports = __webpack_public_path__ + "static/media/dead_disconnected_bat_sel.781822b0.svg";